module.exports = "\r\nsection {\r\n\tfloat: left;\r\n\tmargin-left: 10%;\r\n\twidth: 80%;\r\n}"